import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { SetupPage, CapturePage }  from '../features/capture';
import { ResultsPage }             from '../features/results';
import { ROUTES }                  from '../config/routes';

export const AppRouter: React.FC = () => (
  <BrowserRouter
    future={{
      v7_startTransition:    true,
      v7_relativeSplatPath:  true,
    }}
  >
    <Routes>
      <Route path={ROUTES.home}     element={<SetupPage />}   />
      <Route path={ROUTES.capture}  element={<CapturePage />} />
      <Route path={ROUTES.results}  element={<ResultsPage />} />
    </Routes>
  </BrowserRouter>
);
